import clickStreamInstance from "./clickStreamWrapper";

import {
	isMobile
} from "./utility";


const getNetworkMetrics = () => {
	const connection =
		navigator.connection ||
		navigator.mozConnection ||
		navigator.webkitConnection;
	// Need to convert Mbps to Kbps and ceil it - Since there was an issue with eVar46 for negative or float values.
	const result = {};
	result.downlinkSpeed = Math.ceil(((connection || {}).downlink || 0) * 1000);
	result.effectiveConnectionType =
		(connection || {}).effectiveType || "Unknown";
	result.roundTripTime = (connection || {}).rtt || 0;
	return result;
};


const analyticsUtil = (sessionKey, domLoadTime) => {
	let result = {};
	if (!window.performance) {
		return result;
	}
	try {
		// Calculating times
		const performance = window.performance;

		let pageLoadedAt;

		/* methods are deprecated, change it later ! ******************************* IMPORTANT */
		if (domLoadTime) {
			pageLoadedAt = domLoadTime;
			sessionStorage.setItem(sessionKey, domLoadTime);
		} else if (sessionKey && sessionStorage.getItem(sessionKey)) {
			pageLoadedAt = sessionStorage.getItem(sessionKey);
		} else if (performance.timing.domContentLoadedEventEnd) {
			pageLoadedAt = performance.timing.domContentLoadedEventEnd;
		}

		// Application execution start time
		if (performance.timing.fetchStart) {
			result.fetchStart = performance.timing.fetchStart;
		}

		// Confirm pageLoad Time - Eliminating Page Refresh Case
		const storedLoadTime = sessionStorage.getItem(sessionKey) || 0;
		if (storedLoadTime - (result.fetchStart || 0) <= 0) {
			sessionStorage.setItem(sessionKey, "0");
			pageLoadedAt = performance.timing.domContentLoadedEventEnd;
		}

		// DNS lookup time
		if (performance.timing.domainLookupEnd) {
			result.extraData3 =
				performance.timing.domainLookupEnd -
				performance.timing.domainLookupStart;
		}
		// TCP + SSL + TTFB Handshake time - connection time
		if (performance.timing.connectEnd) {
			result.extraData4 = (
				performance.timing.connectEnd - performance.timing.connectStart
			)?.toString();
		}
		// resource download time
		if (performance.timing.responseEnd) {
			result.extraData5 = (
				performance.timing.responseEnd - performance.timing.requestStart
			)?.toString();
		}
		// DOM interactive time
		if (pageLoadedAt) {
			result.extraData6 = (
				pageLoadedAt - performance.timing.fetchStart
			)?.toString();
		}
		// browser idea tme
		if (performance.timing.loadEventEnd) {
			result.totalPageLoadTime =
				performance.timing.loadEventEnd - performance.timing.fetchStart;
		}

		// custom calculated page load time
		if (window.pageLoadStartTime) {
			result.totalLoadTime = pageLoadedAt - window.pageLoadStartTime;
		}

		// redirection time
		result.extraData7 = (
			performance.timing.redirectEnd - performance.timing.redirectStart
		)?.toString();

		// Fetching infra info
		result.userAgent = navigator?.userAgent;
		// Device type Mobile/desktop
		result.isMobile = isMobile();

		// screen size width * height
		// if(screen.width) {
		//     result.screenSize = `${screen.width} * ${screen.height}`
		// }
		result = { ...result, ...getNetworkMetrics() };
	} catch (err) {
		// fireLogWithSentry(
		// 	"analyticsUtil.js-->analyticsUtil-->err: Error in calculating pageload timing",
		// 	err
		// );
	}
	return result;
};

const logTimeTaken = () => {
	const initialTime = new Date().getTime();
	return function (endpoint) {
		try {
			const apiSplitBySlash = endpoint.split("/");
			const endTime = new Date().getTime();
			const clickStreamModel = {};
			clickStreamModel.extraData4 =
				apiSplitBySlash[apiSplitBySlash.length - 1];
			clickStreamModel.extraData5 = "api_metrics_shop";
			clickStreamModel.extraData6 = (endTime - initialTime)?.toString();
			clickStreamInstance().sendClickStream(clickStreamModel);
		} catch (err) {
			console.error(err);
		}
	};
}


export {
	getNetworkMetrics,
	analyticsUtil,
	logTimeTaken

}